import uniqid from 'uniqid';
import { Cafe, LegalEntity, PosShift, Wallet, Worker } from '../../apiTypes';
import { createBatch } from '../../utils/api';

type Props = {
  cafeSlug: string;
  worker?: DbDocument<Worker>;
  cafe?: DbDocument<Cafe> | null;
  wallets: DbDocument<Wallet>[];
  legalEntities: DbDocument<LegalEntity>[];
};

export const openPosShift = async ({ worker, cafe, cafeSlug, wallets, legalEntities }: Props) => {
  if (!worker?.credentials.open_close_pos_shifts || !cafe) {
    return {};
  }

  const prroShiftIds: Record<string, string> = {};
  const errors: string[] = [];
  const closedShifts: string[] = [];

  const promises = legalEntities.map(async (legalEntity) => {
    const { enabled, key, cashierToken } = legalEntity?.prroCheckBox || {};

    if (enabled && key && cashierToken && !closedShifts.includes(key)) {
      closedShifts.push(key);

      const res = await fetch('https://api.checkbox.in.ua/api/v1/shifts', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${cashierToken}`,
          'X-License-Key': key,
          'X-Client-Name': 'FireMenu',
          'X-Client-Version': 'v0.1.1',
        },
      });

      const resJson = await res.json();

      if (resJson.id) {
        prroShiftIds[legalEntity.id] = resJson.id;
      }
      if (resJson.message) {
        errors.push(resJson.message);
      }
    }
  });

  await Promise.all(promises);

  const batch = createBatch();

  batch.set<PosShift>(`cafes/${cafeSlug}/posShifts/${uniqid()}`, {
    status: 'created',
    created: Date.now(),
    createdBy: {
      name: worker.name,
      workerId: worker.id,
    },
    startWalletState: wallets.map((w) => ({ id: w.id, hidden: w.hidden, name: w.name, balance: w.balance })),
    prroShiftIds,
  });

  await batch.commit();

  return { errors };
};
